// HomeLogoButton.tsx
import React from 'react';
import styled from "styled-components";
import { Link } from 'react-router-dom';
import Logo from '../../ui/components/Logo';
import Tooltip from '../../ui/components/Tooltip';

const LogoContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0 0 0 8px;
`;

interface HomeLogoButtonProps {
    colorMode?: "dark" | "light";
    linkTo?: string;
    onHomeClick: () => void;
}

const HomeLogoButton: React.FC<HomeLogoButtonProps> = ({ colorMode="dark", linkTo, onHomeClick }) => {
    return (
        <Tooltip text="Home" colorMode="dark">
            <LogoContainer>
                <Link to={linkTo} style={{ textDecoration: 'none' }}>
                    <Logo colorMode={colorMode} size={18} onClick={onHomeClick} />
                </Link>
            </LogoContainer>
        </Tooltip>
    );
};

export default HomeLogoButton;